export var XApplicationNameEnum;
(function (XApplicationNameEnum) {
    XApplicationNameEnum["empresa"] = "internet-banking-client";
    XApplicationNameEnum["escritorio"] = "internet-banking-accountant";
})(XApplicationNameEnum || (XApplicationNameEnum = {}));
